module.exports = __webpack_public_path__ + "img/banner-block.ca191803.svg";